export class TECLASRAPIDAS{
    public Componente:string;
    public Tecla:string;
    public Funcion:string;
    public IdElemento:string;
}